import React from "react";
import sampleUser from "../../assets/user.jpg";
import HeaderCard from "../../components/Employee/Profile/HeaderCard";
import InfoGridSection from "../../components/Employee/Profile/InfoGridSection";
import { useGlobal } from "../../contexts/GlobalContext";
import { formatFieldName } from "../../util/common";

function Profile() {
  const { user } = useGlobal();

  const personalInformationFields = [
    "FirstName",
    "MiddleName",
    "LastName",
    "Suffix",
    "Gender",
    "DateOfBirth",
    "CivilStatus",
    "Address",
    "City",
    "Province",
    "PostalCode",
    "Country",
  ];

  const contactFields = ["Email", "ContactNumber", "AlternateContactNumber"];

  const _personalInformationFields = [];
  const _contactFields = [];

  if (user) {
    personalInformationFields.forEach((field) => {
      if (field === "Address") {
        const addressParts = [
          user.Address,
          user.City,
          user.Province,
          user.PostalCode,
          user.Country,
        ].filter(Boolean);

        _personalInformationFields.push({
          name: "Address",
          value: addressParts.join(", "),
        });
      } else if (
        !["City", "Province", "PostalCode", "Country"].includes(field)
      ) {
        let value = user[field] ?? "";

        if (field === "DateOfBirth" && value) {
          const date = new Date(value);
          if (!isNaN(date)) {
            value = date.toISOString().split("T")[0];
          }
        }

        _personalInformationFields.push({
          name: formatFieldName(field),
          value,
        });
      }
    });

    contactFields.forEach((field) => {
      _contactFields.push({
        name: formatFieldName(field),
        value: user[field] ?? "",
      });
    });
  }

  return (
    <div className="profile-view-container">
      <div className="profile-header-card">
        <HeaderCard />
      </div>

      <div className="profile-grid">
        <InfoGridSection
          title={"Personal Information"}
          fields={_personalInformationFields}
        />
        <InfoGridSection title={"Contact"} fields={_contactFields} />

        <div className="profile-section">
          <h3>Benefits Reference Number</h3>
          <div className="info-grid">
            <div>
              <strong>PhilHealth:</strong> 12-34567891-2
            </div>
            <div>
              <strong>SSS:</strong> 09-8765432-1
            </div>
            <div>
              <strong>Pag-Ibig:</strong> 4321-8765-0987
            </div>
          </div>
        </div>

        <div className="profile-section attendance-summary">
          <h3>Attendance Summary</h3>
          <div className="summary-grid">
            <div className="summary-card">
              <h4>25</h4>
              <p>On Time</p>
              <span>-10% less than last month</span>
            </div>
            <div className="summary-card">
              <h4>3</h4>
              <p>Absent</p>
              <span>+3% increase</span>
            </div>
            <div className="summary-card">
              <h4>10</h4>
              <p>Late Arrivals</p>
              <span>+3% increase</span>
            </div>
            <div className="summary-card">
              <h4>5</h4>
              <p>Early Departures</p>
              <span>-10% less</span>
            </div>
          </div>
        </div>

        <div className="profile-section">
          <h3>Schedules</h3>
          <div className="schedule-grid">
            <div className="day onsite">Mon</div>
            <div className="day onsite">Tue</div>
            <div className="day wfh">Wed</div>
            <div className="day onsite">Thu</div>
            <div className="day onsite">Fri</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Profile;
